import {makeAutoObservable} from "mobx";

export class ManagerStore {

    constructor() {
        makeAutoObservable(this);
    }

    public titleLabel:string|undefined;

    public setTitleLabel(label:string){
        this.titleLabel = label;
    }
}